import { assign, createMachine, Interpreter } from 'xstate'
import { CurrencyRate } from './domain'

type Currencies = Record<string, CurrencyRate>

interface Context {
  currencies: Currencies
}

function getCurrenciesContextInitial(): Context {
  return {
    currencies: {},
  }
}

const schema = {
  states: {
    idle: {},
    fetchingRates: {},
    error: {},
    success: {},
  },
}

export type CurrencyEvents = any

type Schema = typeof schema

export const currenciesStateMachine = createMachine<Context, CurrencyEvents>(
  {
    id: 'currenciesMachine',
    context: getCurrenciesContextInitial(),
    initial: 'fetchingRates',
    states: {
      idle: {},
      fetchingRates: {
        invoke: {
          src: 'fetchCurrencyRates',
          onDone: {
            target: 'success',
            actions: assign({
              currencies: (_, { data }) => {
                return data.reduce((mapped, currency) => {
                  mapped[currency.code] = currency
                  return mapped
                }, {})
              },
            }),
          },
          onError: {
            target: 'error',
            actions: 'logError',
          },
        },
      },
      error: {
        type: 'final',
      },
      success: {
        type: 'final',
      },
    },
  },
  {
    actions: {
      logError: () => {
        throw new Error('currenciesStateMachine logError not implemented')
      },
    },
  },
)

export type CurrenciesMachineInterpreter = Interpreter<Context, Schema>
